import { Controller, FormProvider } from "react-hook-form";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { DefaultTextareaField } from "../../../../common/components/forms/inputs/textareaField/DefaultTextareaField";
import { RenderWhen } from "../../../../common/infrastructure/components/RenderWhen";
import { useReviewForm } from "../../hooks/useReviewForm";
import {
  IReviewFormModel,
  REVIEW_COMMENT_MAX_LENGTH,
} from "../../models/reviewFormModel";
import { StarRating } from "../StarRating/StarRating";
import styles from "./ReviewForm.module.scss";

interface IReviewFormProps {
  initialValues?: IReviewFormModel;
  /** Editing the client's existing review: the button says "Запази". */
  isEdit?: boolean;
  isSaving?: boolean;
  onSubmit: (values: IReviewFormModel) => void;
}

/** Stars and an optional comment; used in "Моите резервации" and on the e-mail page. */
export const ReviewForm = ({
  initialValues,
  isEdit,
  isSaving,
  onSubmit,
}: IReviewFormProps) => {
  const { form, commentLength, handleSubmit } = useReviewForm({
    initialValues,
    onSubmit,
  });

  return (
    <FormProvider {...form}>
    <form className={styles.root} onSubmit={handleSubmit} noValidate>
      <Controller
        name="rating"
        control={form.control}
        render={({ field, fieldState }) => (
          <div className={styles.root_rating}>
            <StarRating
              value={field.value}
              onChange={field.onChange}
              size="large"
            />
            <RenderWhen condition={!!fieldState.error?.message}>
              <span className={styles.root_error}>
                {fieldState.error?.message}
              </span>
            </RenderWhen>
          </div>
        )}
      />

      <div className={styles.root_comment}>
        <DefaultTextareaField
          name="comment"
          label="Коментар (по желание)"
          placeholder="Какво ви хареса? Какво бихме могли да подобрим?"
          rows={4}
          width="100%"
        />
        <span className={styles.root_comment_counter}>
          {`${commentLength}/${REVIEW_COMMENT_MAX_LENGTH}`}
        </span>
      </div>

      <div className={styles.root_submit}>
        <DefaultButton
          label={isEdit ? "Запази" : "Изпрати ревю"}
          type="submit"
          loading={isSaving}
        />
      </div>
    </form>
    </FormProvider>
  );
};
